import { ActivityActionType, Agent } from 'src/interfaces/agent.interface';
import { ProviderSelect } from 'src/pages/Automations/components/ui/ProviderSelect';
import { CRM_PROVIDER_OPTIONS } from 'src/pages/Automations/components/wizard/WizardContext';
import { cn } from 'src/utils/className';

type PostCallActivityTrackingProps = {
  agent: Agent;
  setAgent: (value: React.SetStateAction<Agent>) => void;
  loading?: boolean;
};

export const PostCallActivityTracking = ({
  agent,
  setAgent,
  loading = false,
}: PostCallActivityTrackingProps) => {
  return (
    <div className={cn(loading && 'opacity-50')}>
      <h4>Sync Post-Call Activity to CRM</h4>
      <p className="text-neutral-400 text-sm">
        Automatically record call insights and messaging activity to your CRM.
      </p>

      <div className="flex flex-col gap-2 w-full mt-2">
        <div>
          <ProviderSelect
            key={agent.id}
            label=""
            htmlFor="provider"
            providers={CRM_PROVIDER_OPTIONS}
            selectedProvider={{
              value:
                CRM_PROVIDER_OPTIONS.find(
                  (option) =>
                    option.value ===
                    agent?.activity_actions?.filter(
                      (action) =>
                        action.type ===
                        ActivityActionType.WRITE_ANALYSIS_ACTIVITY,
                    )[0]?.config?.destination_id,
                )?.value ?? '',
              label:
                CRM_PROVIDER_OPTIONS.find(
                  (option) =>
                    option.value ===
                    agent?.activity_actions?.filter(
                      (action) =>
                        action.type ===
                        ActivityActionType.WRITE_ANALYSIS_ACTIVITY,
                    )[0]?.config?.destination_id,
                )?.label ?? 'Select a provider',
            }}
            onChange={(e) => {
              if (!agent) return;
              const rest =
                agent.activity_actions?.filter(
                  (action) =>
                    action.type !== ActivityActionType.WRITE_ANALYSIS_ACTIVITY,
                ) ?? [];

              setAgent({
                ...agent,
                activity_actions: [
                  ...rest,
                  {
                    type: ActivityActionType.WRITE_ANALYSIS_ACTIVITY,
                    config: {
                      provider_type: 'integration_app',
                      destination_id: e.value,
                    },
                  },
                ],
              });
            }}
          />
        </div>
      </div>
    </div>
  );
};
